import React from "react";

export default function VirtualLibrarianUserMenu({
  onMenuItemSelected,
  selectedMenuItem,
}) {
  const handleMenuItemSelected = (value) => {
    onMenuItemSelected(value);
  };

  return (
    <div className="sidebar-navigation">
      <h4>ECHO Enhanced Search</h4>
    </div>
  );
}
